import { A, pipe } from '@mobily/ts-belt';
import React, { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import ProgramTabs from '../../../../components/program-tabs';
import { actions } from '../../../../store/ducks/programs';
import TStore from '../../../../types/store';
import { ProgramSC } from './programs.styled';
import { Empty, Loader } from '@ui';

type ProgramsTabProps = {
  userId: string;
};

const ProgramsTab: React.FC<ProgramsTabProps> = ({ userId }: ProgramsTabProps) => {
  const dispatch = useDispatch();
  const programData = useSelector((store: TStore) => store.programs.programData);
  const programDataStatus = useSelector((store: TStore) => store.programs.getProgramDataStatus);
  const currentLang = useSelector((store: TStore) => store.app.currentLang);
  const providerId = useSelector((state: TStore) => state.users.business[0].id);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    dispatch(actions.getProgramDataRequest({ providerId, userId }));
  }, []);

  // Filter tabs with URL only
  const tabOptions = useMemo(() => {
    return pipe(
      programData,
      A.filter((a) => Boolean(a.url)),
      A.mapWithIndex((i, data) => ({ key: i.toFixed(0), label: data.name, ...data })),
    );
  }, [programData]);

  return (
    <ProgramSC>
      {programDataStatus === 'pending' || programDataStatus === undefined ? (
        <div className="white-bg">
          <Loader loading size="medium" />
        </div>
      ) : tabOptions.length === 0 ? (
        <div className="no-data-alert">
          <Empty title={<FormattedMessage id="tools.no_data_title" />} style={{ margin: 32 }} />
        </div>
      ) : (
        <>
          <ProgramTabs onChange={setActiveTab} selected={activeTab} options={tabOptions} />
          {!tabOptions[activeTab] ? (
            <div className="no-data-alert">
              <Empty title={<FormattedMessage id="tools.no_data_title" />} />
            </div>
          ) : (
            <iframe
              src={`${tabOptions[activeTab].url}/?accessToken=${tabOptions[activeTab].accessToken}&userId=${userId}&lang=${currentLang}`}
              width={'100%'}
              height={'100%'}
            />
          )}
        </>
      )}
    </ProgramSC>
  );
};

export default React.memo(ProgramsTab);
